"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConditionNodeIds = getConditionNodeIds;
exports.getQueryNodeIds = getQueryNodeIds;
const lodash_1 = __importDefault(require("lodash"));
const conditions_1 = require("./conditions");
const queries_1 = require("./queries");
function getConditionNodeIds(conditions) {
    const nodeIds = new Set();
    conditions.conditions.forEach((condition) => {
        if ((0, conditions_1.isConditionSingleField)(condition)) {
            nodeIds.add(condition.nodeId);
        }
        if ((0, conditions_1.isConditions)(condition) && !(0, conditions_1.isConditionCollection)(condition)) {
            getConditionNodeIds(condition).forEach((nodeId) => nodeIds.add(nodeId));
        }
        if ((0, conditions_1.isConditionCollection)(condition)) {
            const { collection, conditions: collectionConditions } = condition;
            nodeIds.add(collection);
            if (!lodash_1.default.isEmpty(collectionConditions)) {
                // using `_.isEmpty` because our type checking can miss collection conditions with `conditions: undefined`.
                getConditionNodeIds({ conditions: collectionConditions }).forEach((nodeId) => nodeIds.add(nodeId));
            }
        }
        if ((0, conditions_1.isConditionQuery)(condition)) {
            getQueryNodeIds(condition.query).forEach((nodeId) => nodeIds.add(nodeId));
        }
        if ((0, conditions_1.hasControlValue)(condition)) {
            nodeIds.add(condition.controlValue);
        }
        if ((0, conditions_1.hasControlValueQuery)(condition)) {
            getQueryNodeIds(condition.controlValueQuery).forEach((nodeId) => nodeIds.add(nodeId));
        }
    });
    return nodeIds;
}
function getNodeIdsFromSelectWithCondition(selectWithConditions) {
    const nodeIds = new Set();
    nodeIds.add(selectWithConditions.nodeId);
    getConditionNodeIds(selectWithConditions.selectIf).forEach((nodeId) => nodeIds.add(nodeId));
    return nodeIds;
}
function getNodeIdsFromSelect(select) {
    const selectNodeIds = select.filter((selectItem) => !queries_1.NON_NODE_ID_TO_KEEP.includes(selectItem));
    return selectNodeIds;
}
function getQueryNodeIds(query) {
    const { select, subQuery, selectWithConditions, selectRepeatable, operatorParams } = query;
    const nodeIds = new Set();
    getNodeIdsFromSelect(select).forEach((nodeId) => nodeIds.add(nodeId));
    if (selectWithConditions) {
        selectWithConditions.forEach((selectCondition) => {
            getNodeIdsFromSelectWithCondition(selectCondition).forEach((nodeId) => nodeIds.add(nodeId));
        });
    }
    if (selectRepeatable) {
        selectRepeatable.forEach((repeatableSelect) => {
            const { select, selectWithConditions, fromCollection } = repeatableSelect;
            nodeIds.add(fromCollection);
            if (select) {
                // select is a string here, not an array
                nodeIds.add(select);
            }
            if (selectWithConditions) {
                getNodeIdsFromSelectWithCondition(selectWithConditions).forEach((nodeId) => nodeIds.add(nodeId));
            }
        });
    }
    if (subQuery) {
        getQueryNodeIds(subQuery).forEach((nodeId) => nodeIds.add(nodeId));
    }
    if (operatorParams) {
        const { fetch } = operatorParams;
        if (fetch?.firstNonEmptyValueAt) {
            fetch.firstNonEmptyValueAt.forEach((nodeId) => nodeIds.add(nodeId));
        }
    }
    return nodeIds;
}
